import { Fab, Tooltip } from '@mui/material'
import { AutoAwesome } from '@mui/icons-material'

const FloatingChatButton = ({ onClick }) => {
  return (
    <Tooltip title="Assistente IA" placement="left">
      <Fab
        color="primary"
        onClick={onClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1199,
        }}
      >
        <AutoAwesome />
      </Fab>
    </Tooltip>
  )
}

export default FloatingChatButton
